import SvgIcon, { type SvgIconProps } from "@mui/material/SvgIcon";

const size = {
  small: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.00031 5.93292C9.14159 5.93311 10.0667 6.85899 10.0667 8.00031C10.0665 9.14147 9.14148 10.0665 8.00031 10.0667C6.85906 10.0667 5.9331 9.14158 5.93292 8.00031C5.93292 6.85888 6.85895 5.93292 8.00031 5.93292Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00001 3.33331C5.28342 3.33331 2.96922 5.15982 2.09024 7.71775C2.02741 7.90059 2.02741 8.09937 2.09024 8.28221C2.96921 10.8401 5.28342 12.6666 8.00001 12.6666C10.7166 12.6666 13.0308 10.8401 13.9098 8.28222C13.9726 8.09937 13.9726 7.90059 13.9098 7.71774C13.0308 5.15983 10.7166 3.33331 8.00001 3.33331Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.33331 1.33331L14.6666 14.6666"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  medium: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 8.7998C13.7674 8.79982 15.2002 10.2326 15.2002 12C15.2002 13.7674 13.7674 15.2002 12 15.2002C10.2327 15.2002 8.7998 13.7674 8.7998 12C8.7998 10.2326 10.2327 8.7998 12 8.7998Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 5C7.87562 5 4.36956 7.80674 3.08826 11.717C3.02806 11.9007 3.02806 12.0993 3.08826 12.283C4.36955 16.1932 7.87562 19 12 19C16.1243 19 19.6304 16.1932 20.9117 12.283C20.9719 12.0993 20.9719 11.9007 20.9117 11.717C19.6304 7.80676 16.1243 5 12 5Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M2 2L22 22" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  large: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.9997 11.6667C18.3929 11.6667 20.3335 13.6065 20.3337 15.9997C20.3337 18.393 18.393 20.3337 15.9997 20.3337C13.6067 20.3335 11.6667 18.3929 11.6667 15.9997C11.6669 13.6066 13.6068 11.6668 15.9997 11.6667Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 6.66669C10.4679 6.66669 5.7701 10.454 4.0873 15.7165C4.02841 15.9007 4.02841 16.0993 4.0873 16.2835C5.77008 21.546 10.4679 25.3334 16 25.3334C21.5321 25.3334 26.2299 21.546 27.9127 16.2835C27.9716 16.0993 27.9716 15.9007 27.9127 15.7165C26.2299 10.454 21.5321 6.66669 16 6.66669Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.66669 2.66666L29.3334 29.3333"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
};

type FontSize = "small" | "medium" | "large";

function EyeOffIcon(props: SvgIconProps) {
  const item = size[((props.fontSize as FontSize) || "medium") as FontSize];
  return <SvgIcon {...props}>{item}</SvgIcon>;
}
export default EyeOffIcon;
